<div class="container mt-4">
    <div class="row">
        <div class="col-12">
            {{ 'documentUpload.checklistInstruction' | translate }}
        </div>
    </div>

    <!-- toggle help ------------------------------------------------------- -->
    <div class="row py-2">
        <div class="col-12">
            <button class="btn doc-collapsible" (click)="showDocumentInformation = !showDocumentInformation">
                {{ 'documentUpload.whatDocumentsNeeded' | translate }}
                <i *ngIf="showDocumentInformation" class="toggle fa fa-angle-down"></i>
                <i *ngIf="!showDocumentInformation" class="toggle fa fa-angle-right"></i>
            </button>
        </div>
    </div>

    <!-- checklist --------------------------------------------------------- -->
    <!-- UHONS -->
    <div class="document-information-wrapper mt-2"
         *ngIf="showDocumentInformation && applicationType === AssistanceApplicationType.UHONS">
        <div class="row w-100">
            <div class="col-12">
                <!-- Photo ID -->
                <div class="mb-2">
                    <i tooltip="Please add this required document" placement="top" container="body" *ngIf="!photoIdStatus"
                       class="fa fa-exclamation-circle me-2 missing-color"></i>
                    <i *ngIf="photoIdStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                    <span>Photo ID</span>
                </div>
                <!-- Employment Status -->
                <div class="mb-2">
                    <i *ngIf="!employmentStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                    <i *ngIf="employmentStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                    <span>At least one from the following list:</span>
                </div>
                <ul class="mb-3">
                    <li>Utility bill</li>
                    <li>Personal property tax statement</li>
                    <li>Tax return transcript</li>
                    <li>Bank statement</li>
                    <li>Letter from government or court</li>
                    <li>Statement of government benefits
                        <ul>
                            <li>SSI/SSDI award letter</li>
                            <li>Unemployment award</li>
                            <li>WIC or SNAP award letters or benefit statements</li>
                        </ul>
                    </li>

                </ul>
                <!-- Income Status -->
                <div class="mb-2">
                    <i *ngIf="!incomeStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                    <i *ngIf="incomeStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                    <span>At least one of the following for ALL adults</span>
                </div>
                <ul class="mb-2">
                    <li>2 check stubs that are less than 90 days old</li>
                    <li>Pension letter</li>
                    <li>Government benefit statement letters
                        <ul>
                            <li>SSI/SSDI award letter</li>
                            <li>Unemployment award</li>
                            <li>WIC or SNAP award letters or benefit statements</li>
                        </ul>
                    </li>
                    <li>
                        If self-employed:
                    </li>
                    <ul>
                        <li>Most recent tax returns</li>
                        <li>Profit and loss statement</li>
                    </ul>

                </ul>

                <div class="mb-1"
                     *ngIf="baseForm.errors?.incomeDocumentRequiredForSelfEmployed">
                    <div class="text-danger">
                        <i class="fa fa-exclamation-circle me-2"></i>
                        <span>Please provide tax returns and/or profit and loss statements for each self-employed adult.</span>
                    </div>
                </div>

                <div class="mb-1">
                    <div class="text-danger"
                         *ngIf="baseForm.errors?.incomeDocumentRequiredForNonSelfEmployed">
                        <i class="fa fa-exclamation-circle me-2"></i>
                        <span>Please provide sufficient income documents for all non-self-employed adults.</span>
                    </div>
                </div>

                <ng-container *ngIf="requestingUtilityAssistance">
                    <div class="mb-2">
                        <i *ngIf="!utilityBillStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="utilityBillStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>{{ utilityBillLabel }} or Shut-off Notice</span>
                    </div>
                </ng-container>

                <ng-container *ngIf="requestingChildcareAssistance">
                    <div class="mb-2">
                        <i *ngIf="!childcareBillStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="childcareBillStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Childcare Bill or Statement</span>
                    </div>
                </ng-container>

                <ng-container *ngIf="requestingCarRepairAssistance">
                    <div class="mb-2">
                        <i *ngIf="!carRepairEstimateStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="carRepairEstimateStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Car Repair Bill Estimate</span>
                    </div>
                    <ul class="mb-2">
                        <li>Bill or estimate must be in the name of the applicant (including year, make/model of the
                            repair vehicle)
                            <ul>
                                <li>Repair service(s) must be outlined</li>
                                <li>Repair company’s name and address must be on the bill or estimate</li>
                                <li>Repair must cost will result in the car being operable</li>
                            </ul>
                        </li>
                    </ul>
                </ng-container>

                <ng-container *ngIf="requestingRentAssistance">
                    <div class="mb-2">
                        <i *ngIf="!leaseAgreementStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="leaseAgreementStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Lease Agreement</span>
                    </div>

                    <div class="mb-2">
                        <i *ngIf="delinquentRentNoticeStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <i *ngIf="!delinquentRentNoticeStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <span>Delinquent Rent Notice</span>
                    </div>
                </ng-container>

                <ng-container *ngIf="requestingEvictionAssistance">
                    <div class="mb-2">
                        <i *ngIf="!evictionStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="evictionStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Eviction Notification</span>
                    </div>
                    <ul class="mb-2">
                        <li>Attach court notice or screenshot of court record</li>
                    </ul>
                </ng-container>

                <ng-container *ngIf="requestingCarRepairAssistance">
                    <div class="mb-2">
                        <i *ngIf="!proofOfIncome" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="proofOfIncome" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Proof of Employment</span>
                    </div>
                </ng-container>

                <ng-container *ngIf="isPublic">
                    <div class="mb-2">
                        <i *ngIf="!ssnProofStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="ssnProofStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>At least one proof of Social Security Number(s) for all household members</span>
                        <ul class="mb-2">
                            <li>Social Security Card</li>
                            <li>SSI/SSDI award letter</li>
                            <li>Tax return with the social security numbers for all household members</li>
                        </ul>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <!-- UFF -->
    <div class="document-information-wrapper mt-2"
         *ngIf="showDocumentInformation && applicationType === AssistanceApplicationType.UFF">
        <div class="row w-100">
            <div class="col-12">

                <!-- core docs -->
                <div class="mb-2">
                    <i *ngIf="!photoIdStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                    <i *ngIf="photoIdStatus" class="fa fa-check-circle-o  me-2 check-color"></i>
                    <span>Photo ID</span>
                </div>

                <div class="mb-2">
                    <i *ngIf="!employmentStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                    <i *ngIf="employmentStatus" class="fa fa-check-circle-o  me-2 check-color"></i>
                    <span>At least one from the following list:</span>
                </div>
                <ul class="mb-3">
                    <li>Utility bill</li>
                    <li>Personal property tax statement</li>
                    <li>Tax return transcript</li>
                    <li>Bank statement</li>
                    <li>Letter from government or court</li>
                    <li>Statement of government benefits
                        <ul>
                            <li>SSI/SSDI award letter</li>
                            <li>Unemployment award</li>
                            <li>WIC or SNAP award letters or benefit statements</li>
                        </ul>
                    </li>
                </ul>

                <div class="mb-2">
                    <i *ngIf="!incomeStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                    <i *ngIf="incomeStatus" class="fa fa-check-circle-o  me-2 check-color"></i>
                    <span>At least one of the following for ALL adults</span>
                </div>
                <ul class="mb-2">
                    <li>2 check stubs (&lt; 90 days old)</li>
                    <li>Pension letter</li>
                    <li>Government benefit statement letters
                        <ul>
                            <li>SSI/SSDI award letter</li>
                            <li>Unemployment award</li>
                            <li>WIC or SNAP award statements</li>
                        </ul>
                    </li>
                    <li>If self-employed:
                        <ul>
                            <li>Most recent tax returns</li>
                            <li>Profit &amp; loss statement</li>
                        </ul>
                    </li>
                </ul>

                <!-- income errors -->
                <div class="text-danger mb-1" *ngIf="baseForm.errors?.incomeDocumentRequiredForSelfEmployed">
                    <i class="fa fa-exclamation-circle me-2"></i>Please provide tax returns and/or profit &amp; loss
                    statements for each self-employed adult.
                </div>
                <div class="text-danger mb-1" *ngIf="baseForm.errors?.incomeDocumentRequiredForNonSelfEmployed">
                    <i class="fa fa-exclamation-circle me-2"></i>Please provide sufficient income documents for all
                    non-self-employed adults.
                </div>

                <div class="mb-2">
                    <i *ngIf="!ssnProofStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                    <i *ngIf="ssnProofStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                    <span>At least one proof of Social Security Number(s) for all household members</span>
                    <ul class="mb-2">
                        <li>Social Security Card</li>
                        <li>SSI/SSDI award letter</li>
                        <li>Tax return with the social security numbers for all household members</li>
                    </ul>
                </div>

                <!-- utility -->
                <ng-container *ngIf="requestingUtilityAssistance">
                    <div class="mb-2">
                        <i *ngIf="!utilityBillStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="utilityBillStatus" class="fa fa-check-circle-o  me-2 check-color"></i>
                        <span>{{ utilityBillLabel }} or Shut-off Notice</span>
                    </div>
                    <ul class="mb-3">
                        <li>Current bill (from past 30&nbsp;days) with:
                            <ul>
                                <li>Client’s name</li>
                                <li>Account number</li>
                                <li>Amount due (including late fees)</li>
                                <li>Address of premises (including city and state)
                                    <ul>
                                        <li>Address must be currently occupied by enrolled family</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </ng-container>

                <!-- childcare -->
                <ng-container *ngIf="requestingChildcareAssistance">
                    <div class="mb-2">
                        <i *ngIf="!childcareBillStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="childcareBillStatus" class="fa fa-check-circle-o  me-2 check-color"></i>
                        <span>Childcare Bill or Statement</span>
                    </div>
                </ng-container>

                <!-- car-repair -->
                <ng-container *ngIf="requestingCarRepairAssistance">
                    <div class="mb-2">
                        <i *ngIf="!carRepairEstimateStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="carRepairEstimateStatus" class="fa fa-check-circle-o  me-2 check-color"></i>
                        <span>Car Repair Bill / Estimate</span>
                    </div>
                    <ul class="mb-3">
                        <li>Repairs must return the car to drivable and road‑safe status.</li>
                        <li>Bill or estimate (from past 30&nbsp;days) with:
                            <ul>
                                <li>Client’s name</li>
                                <li>Repair service(s)</li>
                                <li>Quoted service price</li>
                                <li>Repair company’s name and address</li>
                            </ul>
                        </li>
                    </ul>
                </ng-container>

                <!-- rent -->
                <ng-container *ngIf="requestingRentAssistance">
                    <div class="mb-2">
                        <i *ngIf="!leaseAgreementStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="leaseAgreementStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Lease Agreement</span>
                    </div>
                    <ul class="mb-2">
                        <li>First and last pages showing:
                            <ul>
                                <li>Tenant’s name</li>
                                <li>Monthly rent amount</li>
                                <li>Address of leased premises (including city and state)
                                    <ul>
                                        <li>Address must be currently occupied by enrolled family</li>
                                    </ul>
                                </li>
                                <li>Landlord/realtor name, address, and contact number</li>
                            </ul>
                        </li>
                    </ul>

                    <div class="mb-2">
                        <i *ngIf="!landlordOwnershipStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="landlordOwnershipStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Landlord proof of ownership</span>
                    </div>
                    <ul class="mb-2">
                        <li>Copy of Assessor’s Office documentation</li>
                    </ul>

                    <div class="mb-2">
                        <i *ngIf="!rentLandlordFormStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="rentLandlordFormStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>UFF Rental Assistance – Landlord Form</span>
                    </div>

                    <div class="mb-2">
                        <i *ngIf="delinquentRentNoticeStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <i *ngIf="!delinquentRentNoticeStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <span>Delinquent Rent Notice</span>
                    </div>
                    <ul class="mb-2">
                        <li>Include:
                            <ul>
                                <li>Tenant’s name</li>
                                <li>Address of leased premises</li>
                                <li>Monthly rent amount</li>
                                <li>Number of months delinquent</li>
                                <li>Current amount due (including late fees)</li>
                                <li>Landlord/realtor name, address, and contact number</li>
                            </ul>
                        </li>
                    </ul>
                </ng-container>

                <ng-container *ngIf="requestingEvictionAssistance">
                    <div class="mb-2">
                        <i *ngIf="!evictionStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="evictionStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Eviction Notification</span>
                    </div>
                    <ul class="mb-2">
                        <li>Include:
                            <ul>
                                <li>Tenant’s name</li>
                                <li>Address of leased premises</li>
                                <li>Current amount due (including fees)</li>
                                <li>Landlord/realtor name, address, and contact number</li>
                            </ul>
                        </li>
                    </ul>
                </ng-container>

                <!-- mortgage -->
                <ng-container *ngIf="requestingMortgageAssistance">
                    <div class="mb-2">
                        <i *ngIf="!mortgageStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="mortgageStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Mortgage Statement</span>
                    </div>
                    <ul class="mb-3">
                        <li>Mortgage statement showing:
                            <ul>
                                <li>Owner’s name and address of home
                                    <ul>
                                        <li>Address must be currently occupied by enrolled family</li>
                                    </ul>
                                </li>
                                <li>Account/loan number</li>
                                <li>Mortgage balance</li>
                                <li>Amount due (including late fees)</li>
                                <li>Mortgage payment address</li>
                            </ul>
                        </li>
                    </ul>
                </ng-container>

                <!-- security deposit -->
                <ng-container *ngIf="requestingSecurityDepositAssistance">
                    <div class="mb-2">
                        <i *ngIf="!leaseAgreementStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="leaseAgreementStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Lease Agreement</span>
                    </div>
                    <ul class="mb-2">
                        <li>First and last pages <strong>OR</strong> formal landlord letter showing:
                            <ul>
                                <li>Tenant’s name</li>
                                <li>Monthly rent amount</li>
                                <li>Address of leased premises (including city and state)
                                    <ul>
                                        <li>Address must be currently occupied by enrolled family</li>
                                    </ul>
                                </li>
                                <li>Landlord/realtor name, address, and contact number</li>
                            </ul>
                        </li>
                    </ul>

                    <div class="mb-2">
                        <i *ngIf="!landlordOwnershipStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="landlordOwnershipStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Landlord proof of ownership</span>
                    </div>
                    <ul class="mb-2">
                        <li>Copy of Assessor’s Office documentation</li>
                    </ul>
                </ng-container>

                <!-- moving expenses -->
                <ng-container *ngIf="requestingMovingExpenseAssistance">
                    <div class="mb-2">
                        <i *ngIf="!movingExpenseStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="movingExpenseStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Moving Expense Bill / Quote</span>
                    </div>
                    <ul class="mb-3">
                        <li>Bill or quote (from past 30&nbsp;days) with:
                            <ul>
                                <li>Client’s name</li>
                                <li>Amount due</li>
                                <li>Client’s old and new addresses</li>
                                <li>Name and address of moving company</li>
                            </ul>
                        </li>
                    </ul>
                </ng-container>

                <!-- car payment -->
                <ng-container *ngIf="requestingCarPaymentAssistance">
                    <div class="mb-2">
                        <i *ngIf="!carPaymentStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="carPaymentStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Car Payment Statement</span>
                    </div>
                    <ul class="mb-3">
                        <li>Current bill/loan statement (from past 30&nbsp;days) with:
                            <ul>
                                <li>Client’s name and address</li>
                                <li>Account/loan number</li>
                                <li>Amount due</li>
                                <li>Dealership/loan servicer’s address</li>
                            </ul>
                        </li>
                    </ul>
                </ng-container>

                <!-- car insurance -->
                <ng-container *ngIf="requestingCarInsuranceAssistance">
                    <div class="mb-2">
                        <i *ngIf="!carInsuranceStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="carInsuranceStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Car Insurance Bill / Quote</span>
                    </div>
                    <ul class="mb-2">
                        <li>Bill or quote (from past 30&nbsp;days) with:
                            <ul>
                                <li>Client’s name</li>
                                <li>Account/quote number</li>
                                <li>Amount due</li>
                                <li>Insurer’s name and address</li>
                            </ul>
                        </li>
                    </ul>
                </ng-container>

                <!-- Any car related requirements' proof of ownership -->
                <ng-container
                        *ngIf="requestingCarInsuranceAssistance || requestingCarPaymentAssistance || requestingCarRepairAssistance">
                    <div class="mb-2">
                        <i *ngIf="!carOwnershipStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="carOwnershipStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Car Ownership (Title)</span>
                    </div>
                </ng-container>

                <!-- tuition -->
                <ng-container *ngIf="requestingTuitionAssistance">
                    <div class="mb-2">
                        <i *ngIf="!tuitionStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="tuitionStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Tuition Statement</span>
                    </div>
                    <ul class="mb-3">
                        <li>Billing statement (from past 30&nbsp;days) showing:
                            <ul>
                                <li>Amount due</li>
                                <li>Student name(s)</li>
                                <li>Institution name and address</li>
                            </ul>
                        </li>
                    </ul>
                </ng-container>

                <!-- educational supplies -->
                <ng-container *ngIf="requestingSchoolSuppliesAssistance">
                    <div class="mb-2">
                        <i *ngIf="!schoolSuppliesStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="schoolSuppliesStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Itemized cost estimate of educational needs</span>
                    </div>
                    <div class="mb-2">
                        <i *ngIf="!childEnrollmentStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="childEnrollmentStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Documentation of child school enrollment, including:</span>
                        <ul>
                            <li>Child's name</li>
                            <li>School name</li>
                            <li>Year of enrollment</li>
                        </ul>
                    </div>
                    <div class="mb-2">
                        <i *ngIf="!childProgressReportStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="childProgressReportStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Copy of child’s progress report, including:</span>
                        <ul>
                            <li>Child’s name</li>
                            <li>School name</li>
                            <li>Date of report</li>
                        </ul>
                    </div>
                </ng-container>

                <!-- tutoring -->
                <ng-container *ngIf="requestingTutoringAssistance">
                    <div class="mb-2">
                        <i *ngIf="!childEnrollmentStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="childEnrollmentStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Documentation of child school enrollment, including:</span>
                        <ul>
                            <li>Child's name</li>
                            <li>School name</li>
                            <li>Year of enrollment</li>
                        </ul>
                    </div>
                    <div class="mb-2">
                        <i *ngIf="!tutoringStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="tutoringStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Tutoring contract or invoice, including:</span>
                        <ul>
                            <li>Services provided</li>
                            <li>Dates of contract or service provided</li>
                            <li>Amount due</li>
                            <li>Child’s name receiving services</li>
                            <li>Vendor contact information</li>
                        </ul>
                    </div>
                </ng-container>

            </div>
        </div>
    </div>

    <!-- STL Water -->
    <div class="document-information-wrapper mt-2"
         *ngIf="showDocumentInformation && applicationType === AssistanceApplicationType.STLWater">
        <div class="row w-100">
            <div class="col-12">

                <!-- core docs -->
                <div class="mb-2">
                    <i *ngIf="!photoIdStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                    <i *ngIf="photoIdStatus" class="fa fa-check-circle-o  me-2 check-color"></i>
                    <span>{{ 'documentChecklist.photoId' | translate }}</span>
                </div>

                <div class="mb-2">
                    <i *ngIf="!residenceStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                    <i *ngIf="residenceStatus" class="fa fa-check-circle-o  me-2 check-color"></i>
                    <span>{{ 'documentChecklist.residenceList' | translate }}</span>
                </div>
                <ul class="mb-2">
                    <li>{{ 'documentChecklist.validStateId' | translate }}</li>
                    <li>{{ 'documentChecklist.validDriversLicense' | translate }}</li>
                    <li>{{ 'documentChecklist.utilityBillResidency' | translate }}</li>
                    <li>{{ 'documentChecklist.taxReturnResidency' | translate }}</li>
                    <li>{{ 'documentChecklist.voterRegistration' | translate }}</li>
                </ul>

                <div class="mb-2">
                    <i *ngIf="!employmentStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                    <i *ngIf="employmentStatus" class="fa fa-check-circle-o  me-2 check-color"></i>
                    <span>{{ 'documentChecklist.employmentList' | translate }}</span>
                </div>
                <ul class="mb-3">
                    <li>{{ 'documentChecklist.utilityBill' | translate }}</li>
                    <li>{{ 'documentChecklist.personalPropertyTax' | translate }}</li>
                    <li>{{ 'documentChecklist.taxReturnTranscript' | translate }}</li>
                    <li>{{ 'documentChecklist.bankStatement' | translate }}</li>
                    <li>{{ 'documentChecklist.govtCourtLetter' | translate }}</li>
                    <li>{{ 'documentChecklist.govtBenefitsStatement' | translate }}
                        <ul>
                            <li>{{ 'documentChecklist.ssiSsdiAward' | translate }}</li>
                            <li>{{ 'documentChecklist.unemploymentAward' | translate }}</li>
                            <li>{{ 'documentChecklist.wicSnapAward' | translate }}</li>
                        </ul>
                    </li>
                </ul>

                <div class="mb-2">
                    <i *ngIf="!incomeStatus && !stlWaterIncomeStatus"
                       class="fa fa-exclamation-circle me-2 missing-color"></i>
                    <i *ngIf="incomeStatus || stlWaterIncomeStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                    <span>{{ 'documentChecklist.incomeAllAdults' | translate }}</span>
                </div>
                <ul class="mb-2">
                    <li>{{ 'documentChecklist.checkStubs' | translate }}</li>
                    <li>{{ 'documentChecklist.employerLetter' | translate }}</li>
                    <li>{{ 'documentChecklist.pensionLetter' | translate }}</li>
                    <li>{{ 'documentChecklist.armedForcesAllotment' | translate }}</li>
                    <li>{{ 'documentChecklist.childSupport' | translate }}</li>
                    <li>{{ 'documentChecklist.unionFunds' | translate }}</li>
                    <li>{{ 'documentChecklist.govtBenefitStatements' | translate }}
                        <ul>
                            <li>{{ 'documentChecklist.ssiSsdiAward' | translate }}</li>
                            <li>{{ 'documentChecklist.tanf' | translate }}</li>
                            <li>{{ 'documentChecklist.unemploymentAward' | translate }}</li>
                            <li>{{ 'documentChecklist.wicSnapAward' | translate }}</li>
                        </ul>
                    </li>
                    <li>{{ 'documentChecklist.selfEmployed' | translate }}
                        <ul>
                            <li>{{ 'documentChecklist.taxReturn' | translate }}</li>
                            <li>{{ 'documentChecklist.profitLoss' | translate }}</li>
                        </ul>
                    </li>
                </ul>

                <!-- income errors -->
                <div class="text-danger mb-1" *ngIf="baseForm.errors?.incomeDocumentRequiredForSelfEmployed">
                    <i class="fa fa-exclamation-circle me-2"></i>{{ 'documentChecklist.errorSelfEmployed' | translate }}
                </div>
                <div class="text-danger mb-1" *ngIf="baseForm.errors?.incomeDocumentRequiredForNonSelfEmployed">
                    <i class="fa fa-exclamation-circle me-2"></i>{{ 'documentChecklist.errorNonSelfEmployed' | translate }}
                </div>

                <ng-container *ngIf="requestingStlWaterAssistance">
                    <div class="mb-3">
                        <i *ngIf="!delinquentWaterBillStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="delinquentWaterBillStatus" class="fa fa-check-circle-o  me-2 check-color"></i>
                        <span>{{ 'documentChecklist.waterBill' | translate }}</span>
                    </div>
                    <div class="mb-2">
                        <i *ngIf="!ssnProofStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="ssnProofStatus" class="fa fa-check-circle-o  me-2 check-color"></i>
                        <span>{{ 'documentChecklist.ssnProof' | translate }}</span>
                        <ul class="mb-2">
                            <li>{{ 'documentChecklist.socialSecurityCard' | translate }}</li>
                            <li>{{ 'documentChecklist.ssiSsdiAward' | translate }}</li>
                            <li>{{ 'documentChecklist.taxReturnSsn' | translate }}</li>
                        </ul>
                    </div>

                </ng-container>
            </div>
        </div>
    </div>

    <!-- STORM / TORNADO RESPONSE -->
    <div class="document-information-wrapper mt-2"
         *ngIf="showDocumentInformation && applicationType === AssistanceApplicationType.STLStorm">
        <div *ngIf="!hasAnyStormAreasSelected">Please select an area to request assistance in</div>
        <div class="row w-100">
            <div class="col-12">
                <!-- Appliances -->
                <ng-container *ngIf="requestingStormAppliances">
                    <div class="mb-2">
                        <i *ngIf="!stormAppliancesStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="stormAppliancesStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Appliances — Invoice or Estimate</span>
                    </div>
                </ng-container>

                <!-- Construction -->
                <ng-container *ngIf="requestingStormConstruction">
                    <div class="mb-2">
                        <i *ngIf="!stormConstructionStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="stormConstructionStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Construction - Bid or Invoice</span>
                    </div>
                </ng-container>

                <!-- HVAC / Plumbing -->
                <ng-container *ngIf="requestingStormHvacPlumbing">
                    <div class="mb-2">
                        <i *ngIf="!stormHvacPlumbingStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="stormHvacPlumbingStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>HVAC / Plumbing - Bid or Invoice</span>
                    </div>
                </ng-container>

                <!-- Mold Remediation -->
                <ng-container *ngIf="requestingStormMoldRemediationAssistance">
                    <div class="mb-2">
                        <i *ngIf="!stormMoldRemediationStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="stormMoldRemediationStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Mold Remediation — Invoice or Estimate</span>
                    </div>
                </ng-container>

                <!-- Other Disaster-Caused Unmet Needs -->
                <ng-container *ngIf="requestingStormOtherDisasterCausedUnmetNeeds">
                    <div class="mb-2">
                        <i *ngIf="!stormOtherUnmetNeedsStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="stormOtherUnmetNeedsStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Other Unmet Needs — Bill or Estimate</span>
                    </div>
                </ng-container>

                <!-- Temporary Storage -->
                <ng-container *ngIf="requestingStormTemporaryStorageAssistance">
                    <div class="mb-2">
                        <i *ngIf="!stormStorageStatus" class="fa fa-exclamation-circle me-2 missing-color"></i>
                        <i *ngIf="stormStorageStatus" class="fa fa-check-circle-o me-2 check-color"></i>
                        <span>Temporary Storage — Statement or Estimate</span>
                    </div>
                </ng-container>

            </div>
        </div>
    </div>

    <!-- upload section ------------------------------------------------------->
    <div class="row py-1">
        <div class="col-12 fw-semi-bold required-label">{{ 'documentUpload.uploadInstruction' | translate }}</div>
    </div>

    <div class="row pb-2">
        <div class="col-12">
                <button class="btn doc-collapsible" (click)="showUploadedDocuments = !showUploadedDocuments">
                    {{ 'documentUpload.addEditDocuments' | translate }}
                    <i *ngIf="showUploadedDocuments" class="toggle fa fa-angle-down"></i>
                    <i *ngIf="!showUploadedDocuments" class="toggle fa fa-angle-right"></i>
                </button>
        </div>
    </div>

    <div class="document-upload-wrapper" *ngIf="showUploadedDocuments">
        <div class="row">
            <div class="col-12">
                <button [disabled]="shouldBeDisabled" type="button" class="btn btn-primary"
                        (click)="addDocumentFormGroup()"><i class="fa fa-plus me-2"></i>{{ 'documentUpload.addDocument' | translate }}
                </button>
            </div>
        </div>

        <ng-container *ngFor="let control of formArray.controls; index as i">
            <div class="row mt-3 mb-3 file-row"
                 [formGroup]="getFileInputFormGroup(i)">
                <div class="col-12">

                    <div *ngIf="isFileInputFormValid(i); else invalid" class="text-success">
                        <i class="fa fa-check fa-2x mt-2"></i>
                    </div>
                    <ng-template #invalid>
                        <div class="text-danger"><i class="fa fa-times-circle fa-2x mt-2"></i></div>
                    </ng-template>

                    <!-- select -->
                    <div *ngIf="!getFileInputFormGroup(i).get('id')?.value" class="row my-2">
                        <div class="col-12">
                            <select formControlName="fileType" class="form-control doc-select w-100">
                                <option [value]="null" disabled>{{ 'documentUpload.selectDocumentType' | translate }}</option>
                                <option *ngFor="let x of docOptions" [value]="x.value">{{ x.label }}</option>
                            </select>
                            <div *ngIf="!getFileInputFormGroup(i).get('fileType')?.value" class="text-danger mt-1">
                                {{ 'documentUpload.errorSelectDocumentType' | translate }}
                            </div>
                        </div>
                    </div>
                    <div *ngIf="getFileInputFormGroup(i).get('id')?.value" class="row my-2">
                        <div class="p-l-1 file-type">{{ getFileType(getFileInputFormGroup(i).get('fileType')?.value) }}</div>
                    </div>

                    <!-- file -->
                    <div class="row my-2">
                        <div class="col-12">
                            <ng-container *ngIf="!getFileInputFormGroup(i).get('file')?.value">
                                <label class="custom-file w-100" [lang]="translate.currentLang">
                                    <input type="file" (change)="onFileChange($event, getFileInputFormGroup(i))"
                                           accept=".jpg,.jpeg,.png,.gif,.bmp,.heic,.pdf,.doc,.docx,.txt,.xlsx"
                                           class="custom-file-input"/>
                                    <span class="custom-file-control"></span>
                                </label>
                                <div class="text-danger mt-1">{{ 'documentUpload.errorUploadDocument' | translate }}</div>
                            </ng-container>
                            <div *ngIf="getFileInputFormGroup(i).get('file')?.value" class="mt-1 ms-2 file-name">
                                {{ getFileInputFormGroup(i).get('file')?.value.name }}
                                <span><a target="_blank"
                                         [href]="apiUrl + getFileInputFormGroup(i).get('file')?.value.fileUrl + '&' + system.getQueryParameters()"><i
                                        class="fa fa-download download-icon" style="padding-left:5px;"></i></a></span>
                            </div>
                        </div>
                    </div>

                    <!-- delete -->
                    <div class="row mb-2 mt-4">
                        <div class="col-12 delete-file-button-container">
                            <button [disabled]="shouldBeDisabled" type="button" class="btn btn-danger"
                                    (click)="removeDoc(i)"><i class="fa fa-trash me-2"></i>{{ 'documentUpload.delete' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
